import { Directive, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { TrackCatalogSuggestionParams } from "@app/models/tracking/track-event-param-type";
import { NavigateSearchSuggestionParams, NavigateSearchbarParams, SetCategorySearchSuggestionSourceParams, SetStartpageSearchSuggestionSourceParams } from "@app/models/tracking/track-history-param-type";
import { isNullish } from "@commonHelpers/math-utils";
import { AlertService } from '@commonServices/alert.service';
import { AlertPositionType } from "@enums/alertPositionType";
import { AnalyticsTrackingFacadeService } from "@services/analytics-tracking-facade.service";
import { BreadcrumbService } from "@services/breadcrumb.service";
import { SearchbarService } from "@services/searchbar.service";
import { TranslationService } from "@services/translation.service";
import { ViewTypeService } from "@services/view-type.service";
import { SearchbarBase } from "./searchbar-base";

@Directive()
export abstract class SearchbarPublicBase extends SearchbarBase {

	protected allreadyTrackedItems: string[] = [];
	protected loadedListItems: string[] = [];

	constructor(
		protected translationService: TranslationService,
		protected breadcrumbService: BreadcrumbService,
		protected router: Router,
		protected searchbarService: SearchbarService,
		protected elRef: ElementRef,
		protected viewTypeService: ViewTypeService,
		protected alertService?: AlertService<AlertPositionType>,
		protected trackingFacadeService?: AnalyticsTrackingFacadeService
	) {
		super(translationService, breadcrumbService, router, searchbarService, elRef, viewTypeService, alertService);
	}

	protected trackSearchSuggestionHistory() {
		this.trackingFacadeService.handleTrackHistory(new NavigateSearchSuggestionParams());
	}

	protected trackSearchSuggestionSourceChanged() {
		this.trackingFacadeService.handleTrackHistory(new NavigateSearchbarParams(!isNullish(this.indexedSearchterm)))
	}

	protected trackSuggestionSourceChangedParams() {
		this.trackingFacadeService.handleTrackHistory(new SetCategorySearchSuggestionSourceParams())
	}

	protected trackGlobalSuggestionSourceChangedParams() {
		this.trackingFacadeService.handleTrackHistory(new SetStartpageSearchSuggestionSourceParams())
	}


	protected sendNewTrackedElements() {
		const elementsToSend = this.loadedListItems.filter(item => !this.allreadyTrackedItems.includes(item));
		if (elementsToSend.length > 0) {
			this.trackingFacadeService.handleTrackEvent(new TrackCatalogSuggestionParams(elementsToSend))
			this.allreadyTrackedItems = this.allreadyTrackedItems.concat(elementsToSend);
		}

	}

	protected trackBeforeNavigate() {
		this.sendNewTrackedElements();
		this.loadedListItems = [];
		this.allreadyTrackedItems = [];
	}

}